import {useQuery} from '@tanstack/react-query';
import {useMerchant, useProfile} from '../../hooks';
import type {TerminalsByMerchant} from '../../model';
import {Fragment, useState} from 'react';
import {TerminalApi} from '../../api';
import {TerminalDialog, TerminalTabs} from './ui';
import {Spinner} from '../../components';

export const TerminalsPage = () => {
    const merchant = useMerchant();
    const profile = useProfile();

    const id = merchant && merchant.id;

    const {data} = useQuery<TerminalsByMerchant>({
        queryKey: [TerminalApi.KEY, 'terminalsByMerchant', id],
        queryFn: () => TerminalApi.getTerminalByMerchantId(id as unknown as string),
    });

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const canCreateTerminal = profile && profile.permissions.includes('terminal.create')

    return (
        <Fragment>
            <h1 className="mb-4 text-4xl w-4/5 text-brand-6 font-bold flex justify-between">
                <span>Terminals</span>
                {canCreateTerminal && <button
                    className="flex flex-center h-10 p-2 text-white active:bg-brand-1/25 rounded-lg text-sm bg-brand-1 "
                    onClick={() => setIsDialogOpen(true)}>
                    New Terminal
                </button>}
            </h1>
            <div className="p-7 w-4/5 bg-white rounded-3xl relative">
                {data
                    ? <TerminalTabs data={data.map(({id, name}) => ({id, name}))}/>
                    : <Spinner/>
                }
            </div>
            {isDialogOpen && canCreateTerminal &&
                <TerminalDialog isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)}/>}
        </Fragment>
    );
};

